import DropTargetFactory, {
  invisibleDropTargetStyle,
} from "../../../../pages/CourseAuthor/PreviewTab/DropTargetFactory";
import { DragAndDropTypes } from "../../../../pages/CourseAuthor/PreviewTab/types";

export default DropTargetFactory(DragAndDropTypes.UnitListItem, props => invisibleDropTargetStyle(props, "5rem"));
